import angular from 'angular';
import myPaymentsListComponent from './my-payments-list.component';
import MyPaymentsListService from './my-payments-list.service';
import myPaymentsListConfig from './my-payments-list.config';

let myPaymentsListModule = angular.module('app.payZone.myPaymentsList',[])
  .component('myPaymentsList', myPaymentsListComponent)
  .service('MyPaymentsListService', MyPaymentsListService)
  .config(myPaymentsListConfig);

export default myPaymentsListModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pay-zone/my-payments/my-payments-list/my-payments-list.js
 **/